import { render } from "./complaint_list.vue?vue&type=template&id=2559ca68&scoped=true&ts=true"
import script from "./complaint_list.vue?vue&type=script&lang=ts"
export * from "./complaint_list.vue?vue&type=script&lang=ts"

import "./complaint_list.vue?vue&type=style&index=0&id=2559ca68&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2559ca68"]])

export default __exports__